import React from 'react';
import { DATA_DYNAMIC_HEAD } from '../../ssr';
function onlyReactElement(list, child) {
    // React children can be "string" or "number" in this case we ignore them for backwards compat
    if (typeof child === 'string' || typeof child === 'number') {
        return list;
    }
    // Adds support for React.Fragment
    if (child.type === React.Fragment) {
        return list.concat(
        // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
        React.Children.toArray(child.props.children).reduce(
        // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
        (fragmentList, fragmentChild) => {
            if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
                return fragmentList;
            }
            return fragmentList.concat(fragmentChild);
        }, []));
    }
    return list.concat(child);
}
const METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/
function unique() {
    const keys = new Set();
    const tags = new Set();
    const metaTypes = new Set();
    const metaCategories = {};
    return (h) => {
        let isUnique = true;
        let hasKey = false;
        if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
            hasKey = true;
            const key = h.key.slice(h.key.indexOf('$') + 1);
            if (keys.has(key)) {
                isUnique = false;
            }
            else {
                keys.add(key);
            }
        }
        // eslint-disable-next-line default-case
        switch (h.type) {
            case 'title':
            case 'base':
                if (tags.has(h.type)) {
                    isUnique = false;
                }
                else {
                    tags.add(h.type);
                }
                break;
            case 'meta':
                for (let i = 0, len = METATYPES.length; i < len; i++) {
                    const metatype = METATYPES[i];
                    // eslint-disable-next-line no-prototype-builtins
                    if (!h.props.hasOwnProperty(metatype))
                        continue;
                    if (metatype === 'charSet') {
                        if (metaTypes.has(metatype)) {
                            isUnique = false;
                        }
                        else {
                            metaTypes.add(metatype);
                        }
                    }
                    else {
                        const category = h.props[metatype];
                        const categories = metaCategories[metatype] || new Set();
                        if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
                            isUnique = false;
                        }
                        else {
                            categories.add(category);
                            metaCategories[metatype] = categories;
                        }
                    }
                }
                break;
        }
        return isUnique;
    };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */
export function reduceComponents(headChildrenElements) {
    return (headChildrenElements
        .reduce(onlyReactElement, [])
        // .filter(unique())
        .reverse()
        .map((c, i) => {
        const key = c.key || i;
        return React.cloneElement(c, { key, [DATA_DYNAMIC_HEAD]: '' });
    }));
}
